export default __webpack_public_path__ + "static/media/Background_00007.07b55dad.png";